module.exports = "/img/_/_/_/assets/images/creeper/battle/legendary//1.jpg?655af6a04bd80542f444bbe6983973f0";